// Parser.js
var Parser = pc.createScript('parser');

Parser.attributes.add('rootWorldWrapper', { type: 'entity' });
Parser.attributes.add('jsonData', { type: 'asset', assetType: 'json' });
Parser.attributes.add("font", {type: "asset", assetType: "font"});

// initialize code called once per entity
Parser.prototype.initialize = function() {
    console.log('init parser');
    this.parseJsonData(this.jsonData.resource);
};

Parser.prototype.parseJsonData = function (data) {
    var textElements = data.textelements;
    
    for (var i = 0; i < textElements.length; i++) {
        var textElement = textElements[i];
        this.createTextEntity(textElement);
    }
};

Parser.prototype.createTextEntity = function (textElement) {
    var textEntity = new pc.Entity();
    textEntity.name = "textEntity";
    
    textEntity.addComponent('element', {
        type: pc.ELEMENTTYPE_TEXT ,
        anchor: new pc.Vec4(0.5,1,0.5,1),
        pivot: new pc.Vec2(0.5,1),
        preset: "Center",
        width: 256 ,
        height: 256,
        fontAsset: this.font,
        fontSize: textElement.fontSize, 
        rect: [0,0,1,0.25],
        color: new pc.Color(textElement.colorR,textElement.colorG,textElement.colorB)
    });
    
    console.log(this.entity.findByName('crosshair'));
    
    textEntity.element.text = textElement.title;
    this.app.root.addChild(textEntity);
    
    
    textEntity.setPosition(textElement.positionX, textElement.positionY, textElement.positionZ);
    textEntity.setEulerAngles(textElement.rotationX, textElement.rotationY, textElement.rotationZ);
    textEntity.setLocalScale(textElement.scaleX, textElement.scaleY, textElement.scaleZ);
    
};

